export default __webpack_public_path__ + "static/media/Lakeside1.5d1e79c6.jpg";